import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { concatAll } from 'rxjs';
import { SpinnerService } from '../../../shared/spinner.service'
import { session } from '../../../../environments/environment.session'
import { ComplaintsService } from '../../service/complaints.service'
import { FileUploadService } from '../../service/file-upload.service'
import Swal from 'sweetalert2';
import { TranslationService } from '../../service/translation.service';

@Component({
  selector: 'app-updatesdetailsmodal',
  templateUrl: './updatesdetailsmodal.component.html',
  styleUrls: ['./updatesdetailsmodal.component.css']
})
export class UpdatesdetailsmodalComponent {
  uploadedFileName: string = '';
  // uploadFile($event: Event) {
  //   throw new Error('Method not implemented.');
  // }
  complaintForm: FormGroup | undefined | any;
  file: File | null = null;
  updatedata: any = {}
  constructor(public translation: TranslationService, private fus: FileUploadService, private fb: FormBuilder, private dialogRef: MatDialogRef<UpdatesdetailsmodalComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private router: Router, private tspinner: SpinnerService, private cs: ComplaintsService) {
    this.updatedata = data
    this.complaintForm = this.fb.group({
      status: ['', Validators.required],
      remarks: ['', Validators.required],
      doc_name: [null]
    });
  }

  



  onFileSelected(event: Event) {
    const target = event.target as HTMLInputElement;
    if (target.files && target.files.length > 0) {
      this.file = target.files[0];
    }
  }

  selectedFileUrlObj: any = {}
  async checkFile(event: any, doc: any) {
    doc = this.updatedata['status'] == 'PENDING' ? 'resolved' : 'closed'

    this.tspinner.show('', '')
    let resp: boolean = await this.fus.validatePdfSize(event);

    if (this.selectedFileUrlObj[doc] && this.selectedFileUrlObj[doc]['url']) {
      URL.revokeObjectURL(this.selectedFileUrlObj[doc]);
    }
    this.selectedFileUrlObj[doc] = {}

    if (!resp) {
      this.tspinner.hide()
      this.selectedFileUrlObj[doc] = {}
      this.selectedFileUrlObj[doc]['url'] = undefined
      this.selectedFileUrlObj[doc].event = undefined;
      this.selectedFileUrlObj[doc].file_name = undefined;
    }

    this.tspinner.hide()
    const file: File = event.target.files[0];
    this.selectedFileUrlObj[doc]['url'] = URL.createObjectURL(file);
    this.selectedFileUrlObj[doc].event = event.target.files[0]
    this.selectedFileUrlObj[doc].file_name = event.target.files[0]['name'];

  }


  async view(doc: string) {
    doc = this.updatedata['status'] == 'PENDING' ? 'resolved' : 'closed'
    if (this.selectedFileUrlObj[doc]['url']) {
      window.open(this.selectedFileUrlObj[doc]['url'], '_blank');
    }
  }

  async submit() {
    const formData = new FormData();

    if (this.complaintForm?.valid) {
      formData.append('status', this.complaintForm?.value.status);
      formData.append('remarks', this.complaintForm?.value.remarks);

    } else {
      Swal.fire(this.translation.t('common', 'oopsTitle'), this.translation.t('officerUpdateComplaints', 'fillRequired'), 'info');
      return
    }
    let obj: any = { b_acct_id: this.erpUser.b_acct_id, ...this.complaintForm.value, create_user_id: this.erpUser.le_id, update_user_id: this.erpUser.le_id, curr_status: this.updatedata['status'], com_id: this.updatedata['com_id'], }
    if (this.selectedFileUrlObj['resolved'] && this.selectedFileUrlObj['resolved']['file_name']) {
      formData.append('file', this.selectedFileUrlObj['resolved']['event']);
      obj.doc = [{ doc_type: 'resolved', doc_name: this.selectedFileUrlObj['resolved']['file_name'] }]
      obj['file_name'] = this.selectedFileUrlObj['resolved']['file_name']
    }

    if (this.selectedFileUrlObj['closed'] && this.selectedFileUrlObj['closed']['file_name']) {
      formData.append('file', this.selectedFileUrlObj['closed']['event']);
      obj.doc = [{ doc_type: 'closed', doc_name: this.selectedFileUrlObj['closed']['file_name'] }]
      obj['file_name'] = this.selectedFileUrlObj['closed']['file_name']
    }

    obj['create_user_name'] =this.erpUser.party_name
    obj['create_role_cd'] =this.erpUser.role_cd.join(" ")
    obj['full_name'] =this.updatedata['full_name'];
    obj['mobile_no'] =this.updatedata['mobile_no'];
    obj['ticket_id'] =this.updatedata['ticket_id'];

    formData.append('data', JSON.stringify(obj));
    this.tspinner.show('', '')
    let resp = await this.cs.resolveComplaints(formData)
    if (resp['error'] == false) {
      this.dialogRef.close(true);
      Swal.fire('Success', resp['data'], 'success')
      this.router.navigate(['/sdp/officer/dashboard']);
    } else {

    }



  }
  onClose() {
    this.dialogRef.close();
  }
  erpUser: any;
  async ngOnInit() {
    this.erpUser = JSON.parse(atob(session.erpUser))
    // this.complaints.filterPredicate = (data, filter: string) => {
    //   const dataStr = Object.values(data).join('').toLowerCase();
    //   return dataStr.includes(filter);
    // }
    // this.resolveComplaints()





  }
  department = {}
  async resolveComplaints() {

    let obj = { b_acct_id: this.erpUser.b_acct_id, status: this.erpUser.status, resolve_by: this.erpUser.resolve_by, resolver_name: this.erpUser.resolver_name, resolve_remark: this.erpUser.resolve_remark };
    // console.log(obj)
    this.tspinner.show('', '')
    let resp = await this.cs.resolveComplaints(JSON.stringify(obj));
    // console.log(resp)
    if (resp['error'] == false) {
      this.tspinner.hide()
      resp['data'].map((x: any) => {
        x['dept'] = []
        if (x.cleanliness) {
          x['dept'].push("cleanliness")
        }
        x.dept = x.dept.join(",");
        // console.log("x.dept",x.dept)
      }
      )

      // this.complaints = new MatTableDataSource(resp['data'])
      // this.complaints.paginator = this.paginator;
      return
    } else {
      this.tspinner.hide()
      Swal.fire('Opps !!', resp['data'], 'error')
      return
    }

  }
}
